import {Button, Tooltip} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {SafeyeNode} from '../../interfaces/SafeyeNode';
import ModalDraggable from '../common/ModalDraggable';
import SafeyeNodeItemUpsert from './SafeyeNodeItemUpsert';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  item?: SafeyeNode;
  mode?: 'view' | 'update';
  prefetch?: boolean;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
  onOpen?: () => void;
  onClose?: Function;
}

const SafeyeNodeItemUpsertButton = <T extends ComponentType = typeof Button>({
  pk,
  item,
  mode,
  prefetch,
  component,
  componentProps,
  children,
  onSubmitted,
  onOpen,
  onClose,
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Tooltip title="Add Camera">
        <Component
          {...componentProps}
          onClick={() => {
            setIsOpened(true);
            onOpen?.();
          }}
        >
          {children}
        </Component>
      </Tooltip>

      {isOpened ? (
        <ModalDraggable open={isOpened}>
          <SafeyeNodeItemUpsert
            pk={pk}
            item={item}
            mode={mode}
            prefetch={prefetch}
            onClose={() => {
              setIsOpened(false);
              onClose?.();
            }}
            onSubmitted={() => {
              onSubmitted?.();
              if (!pk) {
                setIsOpened(false);
                onClose?.();
              }
            }}
          />
        </ModalDraggable>
      ) : null}
    </>
  );
};

export default SafeyeNodeItemUpsertButton;
